import {MainRequest} from 'Services/common';

export interface GetLocateList extends PaginationAntD {
    catid: string;
}
export interface LocateList {
    catid: string; //    所属栏目id
    id: string; //    主键
    parentId: number; //    所属父级id
    positionName: string; //    定位的名称
    positionType: number; //    定位类型 0 列表块定位 1 列表标题定位 2 列表url定位 3内容标题定位 4内容时间定位 5内容本体定位
    positionXpath: string; //    定位的xpath
    valuePosition: string; //    text和其他属性
    children: LocateList[];
}

export function getLocatePage(params?: GetLocateList) {
    return MainRequest.post<SuccessData<LocateList[]>>(
        '/bigdata/getPositions',
        {
            ...params,
            pageNo: params?.current,
            pageSize: params?.pageSize,
        },
    )
        .then(res => res.data.data)
        .then(res => {
            return {
                data: res,
                total: res?.length,
            };
        });
}

export interface LocateEntityItem extends Omit<LocateList, 'id' | 'children'> {
    id?: string;
}
//编辑
export function editLocate(data: LocateEntityItem) {
    return MainRequest.post('/bigdata/savePosition', data);
}

//删除
export function deleteLocate(id: string) {
    return MainRequest.post(`/bigdata/deletePosition`, {
        id,
    });
}
